import React from 'react';
import Button from '../../../../Components/Button/Button';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import Text from '../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './CaseCloseQuestionnaire.module.scss';
import { CaseDoctorSurvey } from '../../../../graphql/graphql';

interface Props {
	onSkip: () => void;
	doctorSurvey: CaseDoctorSurvey;
}

const CaseCloseQuestionnaire: React.FC<Props> = ({ onSkip, doctorSurvey }) => {
	const handleFillOut = () => {
		// @ts-ignore
		window.location.href = `/questionnaire-for-doctor/${doctorSurvey.wizardKey}`;
	};

	return (
		<div className={styles.wrapper}>
			<Text tx='component.caseCloseQuestionnaire.text' />
			<Text tx='component.caseCloseQuestionnaire.text2' />
			<div className={styles.buttons}>
				<Button
					title='component.caseCloseQuestionnaire.button1'
					theme={Theme.GREEN}
					onClick={handleFillOut}
				/>
				<LinkButton
					title='component.caseCloseQuestionnaire.button2'
					theme={Theme.BLUE}
					onClick={onSkip}
				/>
			</div>
		</div>
	);
};

export default CaseCloseQuestionnaire;
